import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { stripUnit } from 'polished'

import Section from 'gatsby-theme-leshen/src/components/Section'
import fluidRange from 'gatsby-theme-leshen/src/utils/fluidRange'

export const EnrollmentHero = styled(Section)(
  ({ darkText, theme }) => css`
    position: relative;
    overflow: hidden;
    z-index: 0;
    color: ${darkText
      ? theme.colors.dark.base.hex
      : theme.colors.light.base.hex};
    background-color: ${darkText
      ? theme.colors.light.darker.hex
      : theme.colors.dark.base.hex};

    @media (min-width: ${theme.breakpoints.md}) {
      padding-right: 50%;
    }
  `
)

export const Content = styled.div(
  ({ split, theme }) => css`
    position: relative;
    z-index: 2;
    ${split &&
      fluidRange('padding-right', [
        stripUnit(theme.spacing.lg),
        stripUnit(theme.spacing.xxl),
      ])};
  `
)

export const BackgroundImage = styled.img(
  ({ theme, split }) => css`
    position: absolute !important;
    top: 0;
    left: ${split ? '50%' : 0};
    bottom: 0;
    right: 0;
    z-index: 1;
    opacity: 0;

    @media (min-width: ${theme.breakpoints.md}) {
      opacity: 1;
    }
  `
)
